var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import DefaultLayer from './default_layer';
import ActionButtons from './action_buttons';
import ButtonComponent from "../../comments/button";
import { useDispatch } from "react-redux";
import { layerAction } from "../../reducers/layer";
var LoginLayer = function () {
    var dispatch = useDispatch();
    var onCloseHandler = function () {
        dispatch(layerAction({
            name: null,
            data: null
        }));
    };
    return (React.createElement(DefaultLayer, null,
        React.createElement(ButtonComponent, { type: 'close', onClick: onCloseHandler }),
        React.createElement(Content, null,
            React.createElement("p", { className: "basic_txt center" },
                React.createElement("b", null,
                    React.createElement("span", { className: "blue" }, "\uB85C\uADF8\uC778\uC774"),
                    " \uD544\uC694\uD55C \uC11C\uBE44\uC2A4 \uC785\uB2C8\uB2E4.")),
            React.createElement(ActionButtons, { actionButton: {
                    text: '로그인 하러가기',
                    action: function () {
                        // 2022-08-05 로그인후 ref 경로 추가
                        //window.location.href = process.env.REACT_APP_SSO_URL as string
                        window.location.href = process.env.REACT_APP_SSO_URL + '?returnUrl=' + encodeURIComponent(window.location.hostname + window.location.pathname);
                    }
                } }))));
};
var Content = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
export default LoginLayer;
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// ./src/detail/components/layer/login_layer.tsx
// module id = 281
// module chunks = 0